<template>
  <li class="border-top py-2 px-2">
    <div class="row align-items-center">
      <div class="col-5">
        <a class="me-2 text-muted" @click="showEntries = !showEntries" style="cursor: pointer;">
          <i class="fa" :class="showEntries ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
        </a>
        {{ line.description }}
      </div>
      <div class="col-2">
        <span class="badge bg-secondary">{{ line.type }}</span>
      </div>
      <div class="col-2 text-muted small">
        {{ line.rate }}
      </div>
      <div class="col-3">
        <div class="d-flex align-items-center justify-content-end gap-2">
          <span>{{ line.sum }} hrs</span>
          <button
            type="button"
            class="btn btn-sm btn-link p-0 text-danger"
            title="Mark as not billable"
            @click="$emit('notBillable', index)"
          >
            <i class="fa fa-trash"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-link p-0"
            :class="line.include ? 'text-success' : 'text-muted'"
            title="Toggle include in invoice"
            @click="$emit('toggleInclude', index, line.include)"
          >
            <i class="fa fa-check"></i>
          </button>
        </div>
      </div>
    </div>

    <ul v-if="showEntries" class="list-unstyled ms-4 mt-2 mb-1">
      <li v-for="entry in line.entries" :key="entry.id" class="row small text-muted py-1">
        <div class="col-4">
          {{ entry.date | moment('DD/MM/YYYY') }}
        </div>
        <div class="col-5">
          <a href="#" class="me-1">
            <img :src="getAvatar(entry.user.id)" :alt="entry.user.name" class="rounded-circle" width="20" height="20" />
          </a>
          {{ entry.user.name }}
        </div>
        <div class="col-3 text-end">
          {{ entry.time }} hrs
        </div>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: ["line", "index"],

  data: function () {
    return {
      showEntries: false
    }
  },

  methods: {
    getAvatar(id) {
      return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar'
    },
  }
}
</script>
